// Route guards: <RequireAuth> for any logged-in user, <RequirePro> for
// the Pro plan, <RequireAdmin> for admin role. While auth is still
// booting we render nothing (avoids a flash to /login).

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function RequireAuth({ children }) {
  const { booted, isAuthed } = useAuth();
  const loc = useLocation();
  if (!booted) return null;
  if (!isAuthed) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return children;
}

export function RequirePro({ children }) {
  const { booted, isAuthed, isPro } = useAuth();
  const loc = useLocation();
  if (!booted) return null;
  if (!isAuthed) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (!isPro)   return <Navigate to="/account/billing?upgrade=1" replace />;
  return children;
}

export function RequireAdmin({ children }) {
  const { booted, isAuthed, isAdmin } = useAuth();
  if (!booted) return null;
  if (!isAuthed) return <Navigate to="/login" replace />;
  if (!isAdmin)  return <Navigate to="/" replace />;
  return children;
}
